import { jsPDF } from "jspdf";

 function getUrlFilePreview(file) {
    const doc = new jsPDF();
    const blobPDF = new Blob([doc.output('blob'), file], { type: 'application/pdf' });

    return URL.createObjectURL(blobPDF);
}
export default getUrlFilePreview;
